var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioMusicProduction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1151 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745132 22.6384 0.745132 50.2484C0.745132 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74513 74.5084 6.74513 50.2484C6.74513 42.7784 8.61513 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3051 70.2384V46.1384C73.3051 44.1184 71.6651 42.4684 69.6351 42.4684C67.6051 42.4684 65.9651 44.1084 65.9651 46.1384V70.2384C65.9651 72.2584 67.6051 73.9084 69.6351 73.9084C71.6651 73.9084 73.3051 72.2684 73.3051 70.2384Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7751 46.0384C79.8251 45.3684 79.8451 44.6984 79.8451 44.0184C79.8451 36.9784 77.3351 30.5084 73.1551 25.4784C74.2251 23.6384 73.7451 21.2484 71.9851 19.9684C66.1451 15.7184 58.6051 13.3784 50.7451 13.3784C42.8851 13.3784 35.3451 15.7184 29.5051 19.9684C27.7451 21.2484 27.2751 23.6384 28.3351 25.4784C24.1551 30.5184 21.6451 36.9784 21.6451 44.0184C21.6451 44.6884 21.6651 45.3684 21.7151 46.0384C18.8651 47.5984 16.9251 50.6384 16.9251 54.1184V62.2484C16.9251 67.3384 21.0451 71.4584 26.1351 71.4584C26.2751 71.4584 26.3851 71.3484 26.3851 71.2084V45.1684C26.3851 45.0284 26.2751 44.9184 26.1351 44.9184C25.5651 44.9184 25.0151 44.9684 24.4751 45.0684C24.4651 44.7184 24.4551 44.3784 24.4551 44.0284C24.4551 37.6784 26.7151 31.8484 30.4751 27.3084C31.7651 27.7984 33.2651 27.6584 34.4551 26.7884C38.8651 23.5784 44.6551 21.8084 50.7451 21.8084C56.8351 21.8084 62.6251 23.5784 67.0351 26.7884C67.7851 27.3284 68.6451 27.5984 69.5051 27.5984C70.0251 27.5984 70.5351 27.4984 71.0151 27.3184C74.7751 31.8684 77.0351 37.6984 77.0351 44.0384C77.0351 44.3884 77.0351 44.7384 77.0151 45.0784C76.4751 44.9784 75.9251 44.9284 75.3551 44.9284C75.2151 44.9284 75.1051 45.0384 75.1051 45.1784V71.2184C75.1051 71.3584 75.2151 71.4684 75.3551 71.4684C75.6751 71.4684 75.9951 71.4484 76.3151 71.4184V73.4184C76.3151 78.0584 72.5451 81.8284 67.9051 81.8284H61.0251C60.4651 80.3784 59.0551 79.3484 57.4051 79.3484H51.0351C48.8851 79.3484 47.1451 81.0884 47.1451 83.2384C47.1451 85.3884 48.8851 87.1284 51.0351 87.1284H57.4051C59.0551 87.1284 60.4651 86.0984 61.0251 84.6484H67.9051C74.0951 84.6484 79.1251 79.6184 79.1251 73.4284V70.6784C82.3351 69.2384 84.5651 66.0184 84.5651 62.2784V54.1484C84.5651 50.6684 82.6251 47.6284 79.7751 46.0684V46.0384Z",
    fill: "#9933CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8451 42.4684C29.8251 42.4684 28.1751 44.1084 28.1751 46.1384V70.2384C28.1751 72.2584 29.8151 73.9084 31.8451 73.9084C33.8751 73.9084 35.5151 72.2684 35.5151 70.2384V46.1384C35.5151 44.1184 33.8751 42.4684 31.8451 42.4684Z",
    fill: "#9933CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1690",
    x: -0.00000339746,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1690"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1690",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1690"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1690",
    result: "effect3_innerShadow_4857_1690"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMusicProduction);
export default __webpack_public_path__ + "static/media/AudioMusicProduction.40147f7e8ff16f204602d5da40d7db03.svg";
export { ForwardRef as ReactComponent };